import React from "react";
import { Alert, AlertDescription } from "ui/components/alert";
import { Icon } from "components";
import { PortalMount } from "components/portal/mount";
import { INFO } from "icons";
import { PAGE_BANNER_PORTAL_ID } from "utils";
import { BILLABLE_HOURS_WARNING_MESSAGE } from "./dashboard-validation";

// Non-blocking warning shown when billable hours are missing (hasBillableHours === false).
// Portaled to the page banner slot at the top of the app layout.
export const BillableHoursWarning = ({ validation }) => {
  if (validation?.hasBillableHours !== false) {
    return null;
  }

  return (
    <PortalMount to={PAGE_BANNER_PORTAL_ID} className="overflow-auto">
      <Alert className="border-amber-300 bg-amber-50 text-amber-800 overflow-auto">
        <Icon icon={INFO} />
        <AlertDescription className="text-amber-800">
          {BILLABLE_HOURS_WARNING_MESSAGE}
        </AlertDescription>
      </Alert>
    </PortalMount>
  );
};
